/*@flow*/
import React from 'react';

type PropsT = { hasError: boolean, error: React$Node };

export default ({ hasError, error }: PropsT): React$Node => {
  if (!hasError || !error) return null;
  return (
    <span
      className="form-text text-danger error-block"
      style={{ fontSize: '1.2rem' }}
    >
      {error}
    </span>
  );
};
